import type { AgencyProduct } from '@/types-agency';
import { AgencyProductCodes } from '@/types-agency';

const PACKAGE_OVERVIEW_PRODUCT_CODES: string[] = [
  AgencyProductCodes.EXPERIENCED,
  AgencyProductCodes.PROFESSIONAL,
  AgencyProductCodes.EXPERT,
  AgencyProductCodes.SME,
  AgencyProductCodes.WELCOME,
  AgencyProductCodes.STARTER,
  AgencyProductCodes.LEGACY_STARTER,
  AgencyProductCodes.RE_CROSS_TUTTI,
  AgencyProductCodes.RE_CROSS_ANIBIS,
];

/** Returns whether an agency's active products permit Package Overview access. */
export const hasAccessToPackageOverview = (products?: AgencyProduct[]): boolean =>
  Boolean(
    products?.some(({ productCode }) => PACKAGE_OVERVIEW_PRODUCT_CODES.includes(productCode)),
  );
